

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import LinkExternal from "~/components/LinkExternal.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        LinkExternal
    },

    // Component Attribute Properties ------------------------------------------

    props: {
        menu: {
            type: Object,
            required: true
        }
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        handleClicked (): void {
            this.$emit("navLinkClicked");
        }
    }

    // -------------------------------------------------------------------------
});
